<template>
  <div v-if="$userInfo">
    <app-detail-header :show-toggle="true"
      :show-delete="false"
      :show-save="false"
      :show-cancel="false"
      :show-new="isCanAdd"
      :show-print="isCanPrint"
      @appDetailHeaderButtonClicked="onHeaderButtonClicked" />
    <div class="columns is-gapless">
      <div class="column is-narrow">
        <orm-batching-list-side-menu v-model="filter"
          @filter="filterList"
          @reset="resetList" />
      </div>
      <div class="column">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
              :columns="columns"
              :page-index="filter.pageIndex"
              :page-size="filter.pageSize"
              :total-rows="totalRows"
              :is-loading="isTableLoading"
              :sort-column="filter.sortColumn"
              :sort-order="filter.sortOrder"
              @pageChanged="onPageChange"
              @sort="sort">
              <tr v-for="(batch, index) in entities"
                :key="batch.batchNo"
                :class="{ 'is-selected' : selectedRow === index }"
                @click="highlightSelected(index, $event)">
                <td>
                  <div v-if="isCanRead"
                    :class="{ 'is-flex is-align-items-center is-justify-content-space-between' : completedStatus.includes(batch.batchStatus)}">
                    <router-link :to="{ path: `/ormbatching/batch/${batch.batchId}` }"
                      append>
                      {{ batch.batchNo }}
                    </router-link>
                    <i v-if="completedStatus.includes(batch.batchStatus)"
                      class="mdi mdi-lock-outline mdi-20px has-text-danger" />
                  </div>
                  <span v-else>{{ batch.batchNo }}</span>
                </td>
                <!-- <td>
                  <a @click="handleInsurerClick(batch.insurerId)">
                    {{ batch.insurer }}
                  </a>
                </td> -->
                <td>{{ $filters.formatBatchStatus(batch.batchStatus) }}</td>
                <td class="has-text-right"
                  :class="{ 'has-text-danger' : batch.count < batch.minBatchSize }">{{ batch.count }}/{{ batch.minBatchSize }}</td>
                <td>{{ $filters.formatDateLocale(batch.batchDate, $userInfo.locale) }}</td>
                <td class="has-text-right">{{ $filters.formatCurrency(batch.agreedArc, $userInfo.locale) }}</td>
                <td class="has-text-right">{{ $filters.formatNumberWithRounding(batch.averageLabourUnit, $userInfo.locale) }}</td>
                <td class="has-text-right">{{ $filters.formatCurrency(batch.averageLabourValue, $userInfo.locale) }}</td>
                <td class="has-text-right">{{ $filters.formatCurrency($filters.formatNumberWithRoundUp(batch.averageLabourRate, $userInfo.locale, 1), $userInfo.locale) }}</td>
                <td class="has-text-right">{{ $filters.formatCurrency(batch.averageRepairCost, $userInfo.locale) }}</td>
                <td class="has-text-right"
                  :class="{ 'has-text-danger': delta(batch) < 0, 'has-text-success': delta(batch) >= 0 }">{{ $filters.formatCurrency(delta(batch), $userInfo.locale) }}</td>
                <td v-if="isCanRead"
                  class="has-text-centered">
                  <!-- <router-link :to="{ path: `${batch.batchId}` }"
                    append>
                    <a class="button is-primary is-small is-inverted tooltip"
                      data-tooltip="Click to edit">
                      <span class="icon is-medium">
                        <i class="mdi mdi-lead-pencil mdi-24px" />
                      </span>
                    </a>
                  </router-link> -->
                  <router-link :to="{ path: `/ormbatching/batch/${batch.batchId}` }"
                    append>
                    <a class="button is-primary is-small is-inverted tooltip"
                      data-tooltip="Click to edit">
                      <span class="icon is-medium">
                        <i class="mdi mdi-lead-pencil mdi-24px" />
                      </span>
                    </a>
                  </router-link>
                </td>
                <!-- <td class="has-text-centered">
                  <button class="button tooltip is-success"
                    data-tooltip="Download Excel"
                    @click="exportToExcel(batch.batchId)">
                    <span class="icon">
                      <i class="mdi mdi-file-download-outline  mdi-24px" />
                    </span>
                  </button>
                </td> -->
              </tr>
              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <span icon="icon is-large">
                      <i class="mdi mdi-48px mdi-emoticon-sad" />
                    </span>
                    <p>Nothing</p>
                  </div>
                </section>
              </template>
            </bulma-table>
          </article>
        </div>
      </div>
    </div>
    <orm-batching-new-modal :active.sync="isNewBatchModalActive"
      v-model="entity"
      @close="closeNewBatchModal"
      @add="handleAddNewBatch" />
  </div>
</template>

<script>
import AppDetailHeader from '@/components/AppDetailHeader'
import OrmBatchingListSideMenu from './OrmBatchingListSideMenu'
import BulmaTable from '@/components/BulmaTable'
import { Columns } from './columns'
import { DateTimeFiltersMixin, NumberFiltersMixin } from '@/components/mixins/filters'
import { AppHeaderButtonTypes } from '@/enums'
import OrmBatchingService from './OrmBatchingService'
import { OrmBatchStatusType } from '@/enums'
import StoreMixin from './storeMixin'
import OrmBatchingNewModal from './OrmBatchingNewModal.vue'
// import InsurerRoutes from '@/views/insurer/route-types'
import { KeyValuePairModel } from '@/classes/viewmodels'
import PrintPreviewService from '@/components/printpreview/PrintPreviewService'
import OrmBatchingRoutes from './route-types'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'OrmBatchingListView',
  components: {
    AppDetailHeader,
    OrmBatchingListSideMenu,
    BulmaTable,
    OrmBatchingNewModal
  },
  mixins: [StoreMixin, DateTimeFiltersMixin, NumberFiltersMixin],
  props: {},
  data: () => {
    return {
      isTableLoading: false,
      totalRows: 0,
      selectedRow: null,
      filter: {
        batchNo: null,
        batchDate: '',
        batchStatus: 0,
        sortColumn: Columns[0].name,
        sortOrder: Columns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 18
      },
      entities: null,
      isNewBatchModalActive: false,
      entity: null
    }
  },
  computed: {
    permission() {
      return this.$user.permissions?.find((p) => p.codeName === 'A130') || {} //ORM Batching
    },
    isCanRead() {
      return this.permission && this.permission.hasRead
    },
    isCanAdd() {
      return this.permission && this.permission.hasAdd
    },
    isCanEdit() {
      return this.permission && this.permission.hasEdit
    },
    isCanPrint() {
      return this.permission && this.permission.hasPrint
    },
    columns() {
      let columns = _cloneDeep(Columns)
      const actionColumn = columns.find((col) => col.name === 'action')
      actionColumn.isVisible = this.isCanRead
      return columns
    },
    filterKey() {
      if (this.$userInfo) {
        return `${this.$userInfo.sessionId}|${this.$route.meta.fkey}`
      } else {
        return ''
      }
    },
    completedStatus() {
      const status = [OrmBatchStatusType.Completed, OrmBatchStatusType.Closed]
      return Object.values(status)
    }
  },
  watch: {},
  created() {
    this.getEntitySummaries()

    if (this.entity === null) {
      this.entity = {
        minBatchSize: 0,
        perQuoteTotalMin: 0,
        perQuoteTotalMax: 0,
        alrLowerThreshold: 0,
        alrUpperThreshold: 0,
        agreedArc: 0
      }
    }
  },
  mounted() {},
  methods: {
    async onHeaderButtonClicked(action) {
      switch (action) {
        case AppHeaderButtonTypes.AddNew:
          await this.addNewClick()
          break
        case AppHeaderButtonTypes.Print:
          break
        case AppHeaderButtonTypes.Delete:
          break
        case AppHeaderButtonTypes.Save:
          break
        case AppHeaderButtonTypes.Cancel:
          break
      }
    },
    highlightSelected(index, event) {},
    onPageChange(pageIndex) {
      this.filter.pageIndex = pageIndex
      this.persistFilter()
      this.getEntitySummaries()
    },
    sort(name, order) {
      this.filter.sortColumn = name
      this.filter.sortOrder = order
      this.persistFilter()
      this.getEntitySummaries()
    },
    filterList() {
      this.filter.pageIndex = 1
      this.persistFilter()
      this.getEntitySummaries()
    },
    resetList() {
      this.filter.batchNo = null
      this.filter.batchStatus = 0
      this.filter.batchDate = ''
      this.filter.messageTypeId = 0
      this.filter.sortColumn = Columns[0].name
      this.filter.sortOrder = Columns[0].defaultOrder
      this.filter.pageIndex = 1
      this.filter.pageSize = 18
      this.persistFilter()
      this.getEntitySummaries()
    },
    persistFilter() {
      sessionStorage.setItem(this.filterKey, JSON.stringify(this.filter))
    },
    retrieveFilter() {
      const filter = JSON.parse(sessionStorage.getItem(this.filterKey))
      if (filter) {
        this.filter = filter
      }
    },
    async getEntitySummaries() {
      this.isTableLoading = true
      this.retrieveFilter()
      this.entities = await OrmBatchingService.getEntitySummaries(this.filter)
      this.totalRows = this.entities.length > 0 ? this.entities[0].totalRows : 0
      this.isTableLoading = false
    },
    delta(batch) {
      return batch.averageRepairCost - batch.agreedArc
    },
    async addNewClick() {
      this.entity = await OrmBatchingService.getNewEntity()
      // this.addStoreItem()
      // const entity = this.get

      this.isNewBatchModalActive = true
    },
    // async addNew() {
    //   this.addStoreItem()
    // },
    closeNewBatchModal() {
      this.isNewBatchModalActive = false
    },
    async handleAddNewBatch() {
      if (this.entity) {
        const utcDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()
        this.entity.batchDate = utcDate.split('.')[0] + 'Z'
        const result = await OrmBatchingService.postEntity(this.entity)
        this.$router.push({ path: OrmBatchingRoutes.OrmBatchingView2.path.replace(':batchId', result.batchId) })
      }
    },
    // handleInsurerClick(insurerId) {
    //   var route = InsurerRoutes.InsurerView.path.replace(':insurerId', insurerId)
    //   this.$router.push(`${route}`)
    // },
    async exportToExcel(batchId) {
      const batchQuotes = await OrmBatchingService.getEntity(batchId)
      let params = Object.assign({
        CompanyID: this.$userInfo.companyId,
        BatchID: batchId,
        QuoteIds: batchQuotes.quoteIds.map((q) => q.quoteId).join(',')
      })
      const keyValuePairs = KeyValuePairModel.convertToKeyValuePairs(params)
      await PrintPreviewService.exportReportEx('rptOrmBatchQuotes', 'excel', keyValuePairs)
    }
  }
}
</script>